export const stringifyWithBigInt = (_key: string, value: unknown) =>
  typeof value === "bigint" ? value.toString() : value
